import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Table, Input } from "antd";
import DiscountManagementDiscounts from "./DiscountManagementDiscounts";
import "./index.css";

const { Search } = Input;

const DiscountManagementTable = () => {
  const { myMenuUsers } = useSelector((state) => state.discountReducer);
  const [searchText, setSearchText] = useState("");

  const filteredData = myMenuUsers.filter((object) =>
    Object.keys(object).some((property) => {
      if (property !== "id") {
        return String(object[property])
          .toLowerCase()
          .includes(searchText.toLowerCase());
      }
      return object.discounts.some((discount) =>
        discount.percent.toString().includes(searchText)
      );
    })
  );

  const discountFilterArray = [
    ...myMenuUsers
      ?.filter((user) => user.discounts.length > 0)
      ?.map((user) => {
        return user.discounts;
      })
      ?.flat()

      ?.map((discount) => {
        return {
          text: `${discount.percent} %`,
          value: discount.percent,
        };
      })
      ?.filter((value, index, self) => {
        return self.findIndex((v) => v.value === value.value) === index;
      }),

    { value: "empty", text: "Няма отстъпки" },
  ];

  const columns = [
    {
      title: "Име",
      dataIndex: "firstName",
      rowKey: "firstName",
      width: "10%",
      sorter: (a, b) => a.firstName.trim().localeCompare(b.firstName.trim()),
      key: "firstName",
      render: (text) => (
        <span className="discount-management-table-text">{text.trim()}</span>
      ),
    },
    {
      title: "Фамилия",
      dataIndex: "lastName",
      rowKey: "lastName",
      width: "10%",
      sorter: (a, b) => a.lastName.trim().localeCompare(b.lastName.trim()),
      key: "lastName",
      render: (text) => (
        <span className="discount-management-table-text">{text.trim()}</span>
      ),
    },
    {
      title: "Имейл",
      dataIndex: "email",
      rowKey: "email",
      width: "10%",
      sorter: (a, b) => a.email.localeCompare(b.email),
      key: "email",
      render: (text) => (
        <span className="discount-management-table-text">{text}</span>
      ),
    },
    {
      title: "Телефонен номер",
      dataIndex: "phoneNumber",
      rowKey: "phoneNumber",
      width: "10%",
      key: "phoneNumber",
      render: (text) => (
        <span className="discount-management-table-text">{text}</span>
      ),
    },
    {
      title: "Отстъпка",
      dataIndex: "discounts",
      key: "discounts",
      width: "10%",
      sorter: (a, b) => {
        const maxPercentA = a.discounts.reduce((max, discount) => {
          const percentString =
            typeof discount.percent === "string"
              ? discount.percent
              : String(discount.percent);
          const percentWithoutHyphen = percentString.replace(/-/g, "");
          return Math.max(max, parseFloat(percentWithoutHyphen));
        }, 0);

        const maxPercentB = b.discounts.reduce((max, discount) => {
          const percentString =
            typeof discount.percent === "string"
              ? discount.percent
              : String(discount.percent);
          const percentWithoutHyphen = percentString.replace(/-/g, "");
          return Math.max(max, parseFloat(percentWithoutHyphen));
        }, 0);

        return maxPercentB - maxPercentA;
      },
      filters: discountFilterArray,
      filterSearch: true,
      onFilter: (value, record) =>
        value === "empty"
          ? record.discounts.length === 0
          : record.discounts
              .map((discount) => discount.percent)
              .includes(value),

      render: (discounts) => (
        <div>
          {discounts.length > 0 ? (
            discounts.map((discount, index) => (
              <span className="discount-management-table-text" key={index}>
                {`${discount.percent}%${
                  index < discounts.length - 1 ? " | " : ""
                }`}
              </span>
            ))
          ) : (
            <span className="discount-management-table-text">
              Няма отстъпки
            </span>
          )}
        </div>
      ),
    },
    {
      title: "Управление на Отстъпките",
      dataIndex: "discounts",
      rowKey: "discounts",
      width: "25%",
      render: (discounts, user) => (
        <DiscountManagementDiscounts discountsArray={discounts} user={user} />
      ),
    },
  ];

  return (
    <>
      <div className="discount-search-container">
        <Search
          className="discount-search-input"
          placeholder="Search..."
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
        />
      </div>

      <Table
        className="discount-management-table"
        rowKey="id"
        key="discount-management-table"
        dataSource={filteredData}
        columns={columns}
        pagination={{ pageSize: 100 }}
      />
    </>
  );
};

export default DiscountManagementTable;
